import React, { Component } from 'react';
import { Divider } from 'primereact/divider';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import { BreadCrumb } from 'primereact/breadcrumb';
import { ApiService } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import DashboardStatCard from '../Dashboard/DashboardStatCard';
import { ContratoUtilizacaoRecursosResumo } from '../ContratoUtilizacao/ContratoUtilizacaoTemplate';

// Menu de contexto "Utilização" - o próprio tenant vendo o histórico/situação atual do seu
// Contrato (mensal, resumo + detalhe por recurso). Contrato pertence à publicação MASTER (não à
// deste tenant), por isso não dá pra reaproveitar o EntityGrid padrão aqui - o backend resolve
// tudo a partir do tenant autenticado (ver ContratoController.meucontrato/
// Contrato.buscarResumoUtilizacao), nunca por id vindo do frontend.
//
// Fatura/nota fiscal (mencionado no card de origem) NÃO está incluído: o sistema ainda não tem
// nenhum mecanismo de emissão de cobrança/NFe (achado de auditoria em aberto, card separado) -
// não há nada real pra linkar aqui ainda.
class MinhaUtilizacaoTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carregando: true,
            contrato: null,
            periodos: [],
            periodoDetalhe: null,
        };
    }

    componentDidMount() {
        this.buscarDados();
    }

    async buscarDados() {
        this.setState({ carregando: true });
        const resultado = await ApiService.post('contrato/meucontrato', {});
        const dados = resultado?.status ? resultado.data : null;
        this.setState({
            contrato: dados?.contrato || null,
            periodos: dados?.periodos || [],
            carregando: false,
        });
    }

    situacaoTemplate(rowData) {
        const aberto = rowData.situacao === 'main.contratoutilizacao.situacao.aberto';
        return (
            <Tag
                severity={aberto ? 'success' : 'secondary'}
                value={UtilService.traduzir('main.contratoutilizacao.situacao.' + (aberto ? 'aberto' : 'fechado'))}
            />
        );
    }

    valorTemplate(campo) {
        return (rowData) => UtilService.formatCurrency(rowData[campo]);
    }

    detalhesTemplate(rowData) {
        return (
            <Button
                icon="pi pi-search"
                label={UtilService.traduzir('main.minhautilizacao.detalhes')}
                text
                onClick={() => this.setState({ periodoDetalhe: rowData })}
            />
        );
    }

    renderBreadcrumb() {
        const { navigate } = this.props;
        if (!navigate) {
            return null;
        }
        return (
            <BreadCrumb
                model={[{ label: UtilService.traduzir('main.minhautilizacao') }]}
                home={{ icon: 'pi pi-home', command: () => navigate({ pathname: '/dashboard' }) }}
                className="border-none surface-section p-4 mb-1"
            />
        );
    }

    render() {
        const { carregando, contrato, periodos, periodoDetalhe } = this.state;
        const periodoAberto = periodos.find((p) => p.situacao === 'main.contratoutilizacao.situacao.aberto');

        if (!carregando && !contrato) {
            return (
                <div className="surface-card border-round">
                    {this.renderBreadcrumb()}
                    <Message severity="info" text={UtilService.traduzir('main.minhautilizacao.semcontrato')} className="w-full m-3" />
                </div>
            );
        }

        return (
            <div style={UtilService.reactEnabled(!carregando)} className="surface-card border-round">
                {this.renderBreadcrumb()}
                <div className="p-3">
                    <div className="grid">
                        <div className="col-12 md:col-4">
                            <DashboardStatCard
                                icone="pi-briefcase"
                                cor="blue"
                                titulo={UtilService.traduzir('main.minhautilizacao.plano')}
                                valor={contrato?.modalidade?.nome || '—'}
                                help={UtilService.traduzir('main.minhautilizacao.plano.help')}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <DashboardStatCard
                                icone="pi-calendar"
                                cor="orange"
                                titulo={UtilService.traduzir('main.minhautilizacao.periodoatual')}
                                valor={periodoAberto?.mesreferencia || '—'}
                                subtitulo={periodoAberto ? UtilService.formatCurrency(periodoAberto.valortotal) : null}
                                help={UtilService.traduzir('main.minhautilizacao.periodoatual.help')}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <DashboardStatCard
                                icone="pi-exclamation-triangle"
                                cor={periodoAberto?.valorexcedente > 0 ? 'red' : 'green'}
                                titulo={UtilService.traduzir('main.minhautilizacao.excedente')}
                                valor={UtilService.formatCurrency(periodoAberto?.valorexcedente || 0)}
                                help={UtilService.traduzir('main.minhautilizacao.excedente.help')}
                            />
                        </div>
                    </div>

                    <Divider align="left" type="solid">
                        <b>{UtilService.traduzir('main.minhautilizacao.historico')}</b>
                    </Divider>

                    <DataTable value={periodos} loading={carregando} stripedRows emptyMessage={UtilService.traduzir('main.minhautilizacao.semperiodos')}>
                        <Column field="mesreferencia" header={UtilService.traduzir('main.contratoutilizacao.mesreferencia')} />
                        <Column field="situacao" header={UtilService.traduzir('main.contratoutilizacao.situacao')} body={(r) => this.situacaoTemplate(r)} />
                        <Column field="valorproporcional" header={UtilService.traduzir('main.contratoutilizacao.valorproporcional')} body={this.valorTemplate('valorproporcional')} />
                        <Column field="valorexcedente" header={UtilService.traduzir('main.contratoutilizacao.valorexcedente')} body={this.valorTemplate('valorexcedente')} />
                        <Column field="valortotal" header={UtilService.traduzir('main.contratoutilizacao.valortotal')} body={this.valorTemplate('valortotal')} />
                        <Column body={(r) => this.detalhesTemplate(r)} style={{ width: '10rem' }} />
                    </DataTable>

                    <Dialog
                        header={periodoDetalhe?.mesreferencia}
                        visible={!!periodoDetalhe}
                        style={{ width: '40rem' }}
                        onHide={() => this.setState({ periodoDetalhe: null })}
                    >
                        {periodoDetalhe && <ContratoUtilizacaoRecursosResumo recursos={periodoDetalhe.recursos} />}
                    </Dialog>
                </div>
            </div>
        );
    }
}

export default MinhaUtilizacaoTemplate;
